import Formatters from '../components/grid-addons/formatters';
import getIn from '../components/connectedForm/utils/getIn';
import { ICustomColumn } from './setColumnsFromArray';
import { cloneDeep } from '@apollo/client/utilities';

import {
  ICustomerAttributeConfig,
  IDiaryAttributeConfig,
  IProductAttributeConfig,
  IPurchaseAttributeConfig,
  ISalesAttributeConfig,
  ISupplierAttributeConfig,
} from '../graphql/schema/p4types';

type IAnyAttributeConfig =
  | ICustomerAttributeConfig
  | IDiaryAttributeConfig
  | IProductAttributeConfig
  | IPurchaseAttributeConfig
  | ISalesAttributeConfig
  | ISupplierAttributeConfig;

function getAttributeRowMetaData(rowData: any, column: any) {
  let values;
  if (column.options?.valuesPath) {
    values = getIn(rowData, column.options.valuesPath);
  } else {
    values = rowData.attributeValues;
  }

  return {
    attributeValues: values,
    attributeConfig: column.options.attributeConfig,
  };
}

/**
 * Important - DO NOT USE DIRECTLY - Go via 'useAttributesForWorkspace', which appropriately memoises the result.
 */
export function setAttributeColumns(
  attributeConfig: Array<{ node: IAnyAttributeConfig }>,
  valuesPath: string,
  columnKey = 'attributeValues.attributeConfig.title',
  isAmendmentResult = false
) {
  const customColumns: { [key: string]: ICustomColumn } = {};

  const fieldName = valuesPath || 'attributeValues';
  attributeConfig.forEach((attr) => {
    customColumns[`${columnKey}.${attr.node.id}`] = {
      name: attr.node.title!,
      fieldName: { fieldName },
      type: attr.node.attributeType!,
      objectType: null,
      formatter: Formatters.AttributeWorkspaceFormatter,
      options: { attributeConfig: attr.node, valuesPath },
      getRowMetaData: getAttributeRowMetaData,
    };
    if (isAmendmentResult) {
      customColumns[`${columnKey}.${attr.node.id}.old`] = {
        name: `Old ${attr.node.title}`,
        fieldName: { fieldName },
        type: attr.node.attributeType!,
        objectType: null,
        formatter: Formatters.AttributeWorkspaceFormatter,
        options: { attributeConfig: attr.node, valuesPath, isOldRecord: true },
        getRowMetaData: getAttributeRowMetaData,
      };
    }
  });

  return customColumns;
}

export const submitAttributeConfigValues = (
  {
    values,
  }: {
    values: IAnyAttributeConfig;
  },
  type: any //customer | product | etc (Actually setting this type forces messy assertions due to use across different types).
) => {
  const submitValues = cloneDeep(values);
  if (!submitValues.attributeReferenceList) return submitValues;
  submitValues.attributeReferenceList.forEach((attributeReference) => {
    if (!attributeReference) {
      //Not actually possible - Making ts happy.
      return;
    }
    attributeReference.type = `${type}AttributeReference`;
    if (!attributeReference.description || attributeReference.description.length === 0) {
      attributeReference.deleted = true;
    }
  });
  return submitValues;
};
